import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { FillPage } from '@/components/layout/PageContainer';
import { useCreateIvr } from '../api';
import { IvrFlowEditor } from '../components/IvrFlowEditor';

export function AddIvrPage() {
  const navigate = useNavigate();
  const create = useCreateIvr();

  return (
    <FillPage>
      <IvrFlowEditor
        mode="create"
        isPending={create.isPending}
        onSave={async (req) => {
          try {
            const res = await create.mutateAsync(req);
            if (res?.message === 'Parameters Incorrect') {
              toast.error(res.message);
              return;
            }
            toast.success(res?.message ?? 'IVR created');
            navigate('/ivr-list');
          } catch {
            toast.error('Could not create the IVR.');
          }
        }}
      />
    </FillPage>
  );
}
